import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom'
import { useDeviceDetect } from '../../utils/use-device-detect'
import { getLocations } from '../../api/locations'
import { checkout } from '../../api/order'
import { spinRoulette } from '../../api/roulette'
import { Store } from 'react-notifications-component'
import L from 'leaflet'
import axios from 'axios'
import './CheckoutPage.scss'
import UserInfo from './components/UserInfo'
import LocationSelector from './components/LocationSelector'
import MapSelector from './components/MapSelector'
import { CustomInput } from '../../components/custom-input/CustomInput'
import PaymentSelector from './components/PaymentSelector'
import DeliveryScheduler from './components/DeliveryScheduler'
import OrderSummary from './components/OrderSummary'
import RouletteWheel from './components/RouletteWheel'
import SuccessModal from './components/SuccessModal/SuccessModal'

const c = 'checkout-page'

const CheckoutPage = () => {
  const generalInfo = JSON.parse(localStorage.getItem('info') || '{}')
  const nearestValidTime = new Date()

  nearestValidTime.setMinutes(
    Math.ceil(nearestValidTime.getMinutes() / 15) * 15
  )
  nearestValidTime.setSeconds(0)
  nearestValidTime.setHours(nearestValidTime.getHours() + 1)

  const { t, i18n } = useTranslation()
  const { isMobile } = useDeviceDetect()
  const { cart, setCart } = useOutletContext<any>()
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [details, setDetails] = useState('')
  const [takeaway, setTakeaway] = useState(false)
  const [date, setDate] = useState<Date | null>(new Date())
  const [time, setTime] = useState<Date | null>(nearestValidTime)
  const [loading, setLoading] = useState(false)
  const [locations, setLocations] = useState<any[]>([])
  const [location, setLocation] = useState<any>(null)
  const [position, setPosition] = useState<L.LatLng | null>(null)
  const [mapLink, setMapLink] = useState('')
  const [showMyLocation, setShowMyLocation] = useState(false)
  const [mapError, setMapError] = useState(false)
  const [showRoulette, setShowRoulette] = useState(false)
  const [prizeNumber, setPrizeNumber] = useState(0)
  const [prizeName, setPrizeName] = useState('')
  const [orderSuccess, setOrderSuccess] = useState(false)
  const [orderSubmitted, setOrderSubmitted] = useState(false)

  const orderPrice = cart.reduce(
    (total: number, item: any) => total + Number(item.price) * item.quantity!,
    0
  )

  const [errorState, setErrorState] = useState({
    name: true,
    phone: true,
    location: true,
  })

  const [clicked, setClicked] = useState(false)
  const [open, setOpen] = useState(false)
  const [allHours, setAllHours] = useState(false)

  const [coordinates, setCoordinates] = useState<Partial<L.LatLng>>({
    lat: 48.35890104494752,
    lng: 27.09073581686573,
  })

  const PAYMENT_METHODS = [
    { label: t('PAYMENT_CASH'), value: '1' },
    { label: t('PAYMENT_CARD_AT_COURIER'), value: '2' },
  ]

  const [payment, setPayment] = useState(PAYMENT_METHODS[0])

  const fetchLocations = () =>
    getLocations().then((res) => setLocations(res.data))

  const getTranslatedName = (item: any) =>
    i18n.language === 'ru' && item?.label_ru ? item.label_ru : item.label

  const formatPhoneNumber = (phone: string) => {
    if (phone.startsWith('0') || phone.startsWith('+373')) {
      return phone.replace(/[()-\s]/g, '')
    }

    return `0${phone}`
  }

  const handleCheckout = () => {
    setClicked(true)

    if (!name || !phone || (!location && !takeaway)) {
      scrollTo({ top: 0, behavior: 'smooth' })

      return
    }

    if (!position) {
      setMapError(true)
      scrollTo({ top: 100, behavior: 'smooth' })

      return
    }

    if (
      generalInfo.isRouletteActive &&
      generalInfo.rouletteMinPrice < orderPrice
    ) {
      setShowRoulette(true)
      setLoading(false)
    } else {
      sendCheckoutRequest('')
      setLoading(true)
    }
  }

  const sendCheckoutRequest = (roulettePrize = '') => {
    const data = {
      name,
      phone: formatPhoneNumber(phone),
      location: location?.label || '',
      details,
      delivery_method: takeaway
        ? 'Pe Loc'
        : date?.toLocaleDateString('en-GB') ===
          new Date().toLocaleDateString('en-GB')
        ? 'Livrare'
        : 'Comanda Prealabila',
      payment: payment.label,
      time: time?.toLocaleTimeString(),
      date: date?.toLocaleDateString('en-GB'),
      delivery_cost: takeaway ? 0 : location?.delivery_price,
      order_price: orderPrice,
      total_price: orderPrice + (takeaway ? 0 : location?.delivery_price),
      mapLink,
      roulette_prize: roulettePrize,
      cart,
    }

    checkout(data)
      .then(() => {
        localStorage.removeItem('pendingOrderSuccess')
        sessionStorage.setItem('orderCompleted', 'true')

        if (roulettePrize) {
          localStorage.setItem('roulettePrize', roulettePrize)
        }

        let successMessage = t('ORDER_SUCCESS')

        if (
          generalInfo.isRouletteActive &&
          generalInfo.rouletteMinPrice < orderPrice &&
          roulettePrize
        ) {
          successMessage += ` ${t('YOU_WON')}: ${roulettePrize}!`
        }

        localStorage.setItem('successMessage', successMessage)

        if (!roulettePrize) {
          Store.addNotification({
            title: 'SUCCESS',
            message: successMessage,
            container: 'top-center',
            type: 'success',
            insert: 'top',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: { duration: 5000, onScreen: true },
          })

          setOpen(true)
          setCart([])
          setLoading(false)
        }
      })
      .catch((err) => {
        localStorage.removeItem('pendingOrderSuccess')
        setLoading(false)
        setShowRoulette(false)
        setOrderSubmitted(false)
        Store.addNotification({
          title: 'ERROR',
          message: `Este o eroare in sistem, va rugam sa ne contactati pe 069 388 892 sau 068 247 847\n${err.message}`,
          container: 'top-center',
          type: 'danger',
          insert: 'top',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: { duration: 5000, onScreen: true },
        })
      })
  }

  const handleRouletteStop = (selectedOption: string) => {
    setPrizeName(selectedOption)

    const successMessage = localStorage.getItem('successMessage')

    if (successMessage) {
      Store.addNotification({
        title: 'SUCCESS',
        message: successMessage,
        container: 'top-center',
        type: 'success',
        insert: 'top',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: { duration: 5000, onScreen: true },
      })
      localStorage.removeItem('successMessage')
    }

    setShowRoulette(false)
    setOpen(true)
    setCart([])
    setLoading(false)
  }

  const handleRouletteSpin = async () => {
    setLoading(true)
    setOrderSubmitted(true)
    localStorage.setItem('pendingOrderSuccess', 'true')

    try {
      const response = await spinRoulette()
      const winningPrize = response.data.prize

      sendCheckoutRequest(winningPrize)

      return { prize: winningPrize }
    } catch (error) {
      setLoading(false)
      setOrderSubmitted(false)
      localStorage.removeItem('pendingOrderSuccess')

      throw error
    }
  }

  useEffect(() => {
    fetchLocations()
  }, [])

  useEffect(() => {
    scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    const pendingOrderSuccess = localStorage.getItem('pendingOrderSuccess')
    const orderCompleted = sessionStorage.getItem('orderCompleted')

    if (pendingOrderSuccess === 'true' || orderCompleted === 'true') {
      setOpen(true)
      setCart([])
      setLoading(false)

      localStorage.removeItem('pendingOrderSuccess')

      const successMessage = localStorage.getItem('successMessage')

      if (successMessage) {
        Store.addNotification({
          title: 'SUCCESS',
          message: successMessage,
          container: 'top-center',
          type: 'success',
          insert: 'top',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: { duration: 5000, onScreen: true },
        })
        localStorage.removeItem('successMessage')
      }
    }
  }, [])

  useEffect(() => {
    if (clicked) {
      setErrorState({ name: !!name, phone: !!phone, location: !!location })
    }
  }, [name, phone, location, clicked])

  useEffect(() => {
    setAllHours(
      date?.toLocaleDateString('en-GB') !==
        new Date().toLocaleDateString('en-GB')
    )
  }, [date])

  useEffect(() => {
    if (position) {
      setMapLink(`https://maps.google.com/?q=${position.lat},${position.lng}`)
    }
  }, [position])

  useEffect(() => {
    const fetchCoordinates = async (loc: string) => {
      if (!loc) {
        setCoordinates({ lat: 48.331216, lng: 26.87127 })

        return
      }

      try {
        const response = await axios.get(
          'https://nominatim.openstreetmap.org/search',
          {
            params: { q: `${loc}, Briceni, Moldova`, format: 'json' },
          }
        )

        if (response.data.length > 0) {
          const { lat, lon } = response.data[0]

          setCoordinates({ lat: parseFloat(lat), lng: parseFloat(lon) })
        }
      } catch (error) {
        console.error('Error fetching coordinates', error)
      }
    }

    fetchCoordinates(location?.label || '')
  }, [location])

  useEffect(() => {
    if (position) {
      setMapError(false)
    }
  }, [position])

  return (
    <div className={c}>
      <div className={`${c}__container`}>
        <div className={`${c}__container-title`}>{t('DELIVERY')}</div>
        <UserInfo
          name={name}
          setName={setName}
          phone={phone}
          setPhone={setPhone}
          errorState={errorState}
          t={t}
        />
        <LocationSelector
          location={location}
          setLocation={setLocation}
          takeaway={takeaway}
          setTakeaway={setTakeaway}
          locations={locations}
          errorState={errorState}
          t={t}
          setPosition={setPosition}
          setCoordinates={setCoordinates}
          getTranslatedName={getTranslatedName}
        />
        <MapSelector
          position={position}
          setPosition={setPosition}
          coordinates={coordinates}
          showMyLocation={showMyLocation}
          setLocationFunction={(func) => setShowMyLocation(true)}
          mapError={mapError}
          t={t}
          loading={loading}
        />
        <CustomInput
          label={t('DETAILS')}
          fullWidth
          value={details}
          multiline
          onChange={(e) => setDetails(e.target.value)}
          rows={3}
          variant='filled'
          size='small'
          sx={{
            mt: 1,
          }}
        />
        <DeliveryScheduler
          date={date}
          setDate={setDate}
          time={time}
          setTime={setTime}
          allHours={allHours}
          nearestValidTime={nearestValidTime}
          generalInfo={generalInfo}
          isMobile={isMobile}
          t={t}
        />
        <div className={`${c}__container-title`} />
        <PaymentSelector
          payment={payment}
          setPayment={setPayment}
          paymentMethods={PAYMENT_METHODS}
        />
        <OrderSummary
          cart={cart}
          takeaway={takeaway}
          location={location}
          loading={loading}
          handleCheckout={handleCheckout}
          t={t}
        />
      </div>
      {generalInfo.isRouletteActive &&
        generalInfo.rouletteMinPrice < orderPrice && (
          <RouletteWheel
            show={showRoulette}
            onStopSpinning={handleRouletteStop}
            onSpin={handleRouletteSpin}
            t={t}
            prizeNumber={prizeNumber}
            setPrizeNumber={setPrizeNumber}
          />
        )}
      <SuccessModal isOpen={open} setIsOpen={setOpen} />
    </div>
  )
}

export default CheckoutPage
